import { createSelector } from 'reselect';
import { RootState } from '..';

const selectAccountReducer = (state: RootState) => state.account;

export const selectAccount = createSelector(selectAccountReducer, account => account);
